<!-- @format -->

<div
	*ngIf="media"
	class="review-media hmf-sharp-radius"
	[ngClass]="mediaSourceContainerClass">
	<button
		class="button-image-container hmf-p-0 hmf-sharp-radius"
		tabindex="0"
		(click)="handleMedia()">
		<picture class="hmf-display-flex hmf-align-items-center hmf-justify-content-center">
			<source
				type="image/webp"
				[srcset]="media.url"
				[attr.lazyLoad]="media.url" />
			<img
				#element
				class="image-element hmf-sharp-radius"
				alt="Photo submitted with review of product"
				[src]="media.url"
				[attr.aria-label]="media.isVideo ? 'Video' : 'Image'"
				[ngClass]="mediaSourceClasses"
				loading="lazy" />

			@if (media.video) {
				<product-reviews-play-button
					class="hmf-position-absolute"></product-reviews-play-button>
			}
		</picture>
	</button>
</div>
